<bci-wk-modal class="modal">
  <div class="container-modal">
    <img
      class="war"
      src="./assets/images/icon-internet-error.png"
      alt="Sin conexion a internet"
    />
    <div class="title wk-padding-top-24">
      <bci-wk-modal-title bciWkTypeH600
        >Sin conexión a internet</bci-wk-modal-title
      >
    </div>
    <div class="subtitle">
      <p>Intenta acceder cuando vuelvas a tener conexión</p>
    </div>
    <bci-wk-modal-actions>
      <button bciWkButtonSecondary (click)="close()">Entendido</button>
      <button bciWkButtonPrimary (click)="close()">Reintentar</button>
    </bci-wk-modal-actions>
  </div>
</bci-wk-modal>
